import { useEffect, useState } from "react";
import { api, fmtDate } from "@/lib/api";
import { PageHead } from "@/components/desk/DeskLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

const GROUPS = [["", "All actions"], ["story.", "Stories"], ["reporter.", "Reporters"], ["user.", "Users"], ["comment.", "Comments"], ["category.", "Categories"], ["tag.", "Tags"], ["settings.", "Settings"]];

export default function AuditPage() {
  const [action, setAction] = useState("");
  const [q, setQ] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ items: [], pages: 1, total: 0 });

  useEffect(() => {
    api.get("/admin/audit", { params: { action: action || undefined, q: query || undefined, page } }).then((r) => setData(r.data));
  }, [action, query, page]);

  return (
    <div data-testid="audit-page">
      <PageHead title="Audit log" sub={`${data.total} recorded actions`}>
        <select data-testid="audit-filter-action" className="h-9 border border-zinc-300 bg-white px-2 text-sm rounded-sm" value={action} onChange={(e) => { setAction(e.target.value); setPage(1); }}>
          {GROUPS.map(([v, l]) => <option key={l} value={v}>{l}</option>)}
        </select>
        <form onSubmit={(e) => { e.preventDefault(); setQuery(q); setPage(1); }}>
          <Input data-testid="audit-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search actor or details" className="h-9 w-56 rounded-sm bg-white" />
        </form>
      </PageHead>
      <div className="bg-white border border-zinc-200 overflow-x-auto">
        <Table data-testid="audit-table">
          <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Actor</TableHead><TableHead>Action</TableHead><TableHead>Target</TableHead><TableHead>Details</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.items.map((a) => (
              <TableRow key={a.id} data-testid={`audit-row-${a.id}`}>
                <TableCell className="text-xs font-mono-meta whitespace-nowrap text-zinc-500">{fmtDate(a.created_at)}</TableCell>
                <TableCell className="text-sm">{a.actor_name}</TableCell>
                <TableCell><span className="font-mono-meta text-xs bg-zinc-100 px-1.5 py-0.5">{a.action}</span></TableCell>
                <TableCell className="text-xs text-zinc-500 font-mono-meta">{a.target_type}:{a.target_id.slice(0, 8)}</TableCell>
                <TableCell className="text-sm max-w-md">{a.details}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <div className="flex items-center gap-3 mt-4">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => setPage(page - 1)} data-testid="audit-prev">Previous</Button>
        <span className="text-sm text-zinc-500">Page {page} of {data.pages || 1}</span>
        <Button size="sm" variant="outline" disabled={page >= data.pages} onClick={() => setPage(page + 1)} data-testid="audit-next">Next</Button>
      </div>
    </div>
  );
}
